import React from 'react';
import { useTranslation } from 'react-i18next';
import Media, { getSecondsFormattedIn } from '../../models/Media';
import MediaThumbnail from '../../models/MediaThumbnail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpand } from '@fortawesome/free-solid-svg-icons';


interface DetailLibraryInfoProps {
    item: Media | MediaThumbnail | null;
    withDuration?: boolean;
};

const DetailLibraryInfo: React.FC<DetailLibraryInfoProps> = (props: DetailLibraryInfoProps) => {

    const [t] = useTranslation();

    if (!props.item) return null;

    const { full_path, size_str, width, height, mime_type, file_duration } = props.item;
    const dimensionText = (width && height) ? `${width} × ${height}` : '—';
    const withDuration = props.withDuration ?? false;

    return (
        <div className="mb-2" style={{ backgroundColor: '#1a1a1a', borderRadius: '6px', overflow: 'hidden' }}>

            <div
                className="px-3 py-2 d-flex align-items-center justify-content-between"
                style={{ fontSize: '0.82rem' }}
            >
                <div>
                    <div className="d-flex align-items-center mb-1">
                        <span style={{ color: '#656465', minWidth: '72px' }}>{t('mediaitem_size')}:</span>
                        <span style={{ color: '#d0d0d0' }}>{size_str}</span>
                    </div>
                    <div className="d-flex align-items-center mb-1">
                        <span style={{ color: '#656465', minWidth: '72px' }}>{t('mediaitem_dimension')}:</span>
                        <span style={{ color: '#d0d0d0' }}>{dimensionText}</span>
                    </div>
                    {withDuration && mime_type?.startsWith('video/') && (
                        <div className="d-flex align-items-center">
                            <span style={{ color: '#656465', minWidth: '72px' }}>{t('mediaitem_duration')}:</span>
                            <span style={{ color: '#d0d0d0' }}>{getSecondsFormattedIn(file_duration ?? 0)}</span>
                        </div>
                    )}
                </div>

                <a
                    href={full_path}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open file"
                    className="ml-3"
                    style={{ color: '#656465', transition: 'color 0.15s' }}
                    onMouseEnter={e => (e.currentTarget.style.color = '#d0d0d0')}
                    onMouseLeave={e => (e.currentTarget.style.color = '#656465')}
                >
                    <FontAwesomeIcon icon={faExpand} size="sm" />
                </a>
            </div>
        </div>
    );

};

export default React.memo(DetailLibraryInfo);
